class MediaPassword {
  constructor() {
    this.passwordDisabled = false;
    // No password set? Get out of here :)
    if (!document.querySelector('.chupacabra') || document.querySelector('.chupacabra') === null) {
      this.passwordDisabled = true;
    }

    let issuedToday = false;
    // Check if localstorage is from today
    if (localStorage.getItem('media_time')) {
      const today = new Date().getDate();
      const lastLogin = new Date(localStorage.getItem('media_time')).getDate();
      issuedToday = lastLogin === today;
    }

    if (!localStorage.getItem('media_login') || !issuedToday) {
      localStorage.setItem('media_login', "false");
    }

    // If accessed by URL
    this.params = new URLSearchParams(window.location.search)
    this.tabName;
    const mediaContent = document.querySelector('[data-tab="media"]');
    if (!mediaContent) return;
    this.mediaClone = mediaContent.cloneNode(true);
    if (!this.passwordDisabled) {
      mediaContent.remove();
    }

    if (this.params.get('tab')) {
      this.tabName = this.params.get('tab')
    }

    // If directly accessed
    if (this.tabName === "media") {
      this.passwordDance();
    }

    // If button is clicked
    document.addEventListener('click', ev => {
      if (ev.target.value === "media") {
        if (document.querySelector('.zoomForm') && !document.querySelector('.zoomForm--hidden')) {
          return;
        }
        this.passwordDance();
      }
    })

  }

  passwordDance() {
    // If escape is pressed
    document.addEventListener('keydown', (ev) => {
      if (ev.key == 'Escape') {
        window.location.href = window.location.href.split('?')[0]
      }
    })
    // Check if already logged in
    if (this.isLoggedIn() === "true" || this.passwordDisabled) {
      this.getContent();
    } else {
      this.getPassword();
    }
  }

  isLoggedIn() {
    return localStorage.getItem('media_login');
  }

  verifyPassword(password) {
    const answer = atob(document.querySelector('.chupacabra').value);
    if (answer === password) {
      localStorage.setItem('media_login', "true");
      localStorage.setItem('media_time', new Date());
      return true;
    } else {
      return false;
    }
  }

  getPassword() {
    // show passwordbox
    let modal = document.querySelector('.passwordModal');
    modal.classList.remove('passwordModal--hidden');
    // listen for mouse-click on submit-button
    let submit = modal.querySelector('[type="submit"]');
    submit.addEventListener('click', ev => {
      this.passwordCheck();
    });
    // Listen for the enter-key on keyboard
    document.addEventListener('keydown', ev => {
      if (ev.code === "Enter") {
        this.passwordCheck();
      }
    })

    // listen for exit
    let exit = modal.querySelector('.passwordModal__exit');
    exit.addEventListener('click', ev => {
      if (this.tabName === 'media') { // if H4XX0R, send'em back to square one
        let url = new URL(window.location)
        window.location = url.origin + url.pathname
      } else {
        modal.classList.add('passwordModal--hidden');
        // document.querySelector('.eventOverview__dynamic').classList.remove('eventOverview__dynamic--hidden')
        let media = document.querySelector('.eventTabs__tab--active')
        media.classList.remove('eventTabs__tab--active')
        let btn = document.querySelector(["[value=overview]"])
        btn.classList.add('eventTabs__tab--active')
        let show = document.querySelector("[data-tab=overview]")
        show.classList.add('event__tab--active')
      }
    });
  }

  passwordCheck() {
    let modal = document.querySelector('.passwordModal');
    let password = modal.querySelector('[type="password"]').value;
    if (this.verifyPassword(password)) {
      // Hide modal, show content
      modal.classList.add('passwordModal--hidden')
      this.getContent(); // Show media content
    } else {
      // show 'wrong password' message
      modal.querySelector('.passwordModal__error').classList.remove('passwordModal__error--hidden');
      this.getPassword();
    }
  }

  getContent() {
    const footer = document.querySelector('.event__content');
    footer.insertAdjacentElement('beforeend', this.mediaClone);

    let oldItem = document.querySelector('.event__tab--active');
    let newItem = document.querySelector(`[data-tab=media]`);
    let oldButton = document.querySelector('.eventTabs__tab--active');
    oldButton.classList.remove('eventTabs__tab--active');
    let newButton = document.querySelector('[value="media"]');
    newButton.classList.add('eventTabs__tab--active');
    if (oldItem) {
      oldItem.classList.remove('event__tab--active');
    }
    newItem.classList.add('event__tab--active');
    oldItem = newItem;
    oldButton = newButton;

    let fullUrl = window.location.toString();
    let hashIndex = fullUrl.indexOf('#');
    if (hashIndex === -1) {
      if (newButton.value) {
        window.history.pushState(null, '', `${fullUrl}#media`);
      } else {
        window.history.pushState(null, '', fullUrl);
      }
    } else {
      let baseUrl = fullUrl.slice(0, hashIndex);
      window.history.pushState(null, '', `${baseUrl}#media`);
    }
  }
}

export default MediaPassword;